export const DEFAULT_PROPOSAL_INFO_FORM_ID = 'default-proposal-info-form';
